import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios';
import CurrencyInput from '../../../../helpers/CurrencyInput';
import MultiTagInput from '../../component/MultiTagInput/MultiTagInput';
import { getToken } from '../../../../helpers/Jwt';
import { confirmModal } from '../../../../helpers/PromptUtils';
import AccountComponent from './component/AccountComponent';
import FormatTransaction from '../../component/FormatTransaction/FormatTransaction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { faGear, faGears } from '@fortawesome/free-solid-svg-icons';
import InputOption from '../../component/InputOption/InputOption';

const TransactionCashBank = () => {
  const { type } = useParams();
  const [ENDPOINT, setENDPOINT] = useState("");

  const [error, setError] = useState(null);
  const [titleTransaction, setTitleTransaction] = useState("");

  const [cashbank, setCashBank] = useState([]);
  const [cashbankType, setCashBankType] = useState("");
  const [cashbankLabel, setCashBankLabel] = useState("");

  const [contact, setContact] = useState([]);
  const [contactLabel, setContactLabel] = useState("");

  const [accountRelationLabel, setAccountRelationLabel] = useState("");
  const [accountType, setAccountType] = useState("");

  const [accounts, setAccounts] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [taxAmount, setTaxAmount] = useState(0);

  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);

  const [isFormatTransactionOpen, setFormatTransactionOpen] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);


  // Formik initial values
  const initialValues = {

  };

  // Validation schema (using Yup)
  const validationSchema = Yup.object({
    // description: Yup.string().required('Deskripsi diperlukan'),
    // amount: Yup.number().required('Jumlah diperlukan').positive('Jumlah harus lebih besar dari nol'),
  });

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PATH_ACCOUNT_CASH_BANK = "api/erpppsu/account/cashbank";
  const PATH_TRANSACTION = "api/erpppsu/cash-bank";
  const PATH_CONTACT = "api/erpppsu/contact/all";

  const fetchData = async (URL) => {
    try {
      const response = await axios.get(URL);
      return response.data; // Return only the data from the response
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.log(err);
    }
  };

  useEffect(() => {
    if (type == 'withdrawal') {
      setENDPOINT("/withdrawals");
      setTitleTransaction("Kirim Uang");

      setCashBankLabel("Bayar Dari");
      setContactLabel("Penerima");
      setCashBankType("cash_and_bank");
      setAccountRelationLabel("Pembayaran Untuk");
      setAccountType("");
    } else if (type == 'bank-deposit') {
      setENDPOINT("/deposit");
      setTitleTransaction("Terima Uang");

      setCashBankLabel("Setor Ke");
      setCashBankType("cash_and_bank");
      setContactLabel("Yang Membayar");
      setAccountRelationLabel("Terima dari");
      setAccountType("accounts_receivable");
    }
  }, [type])

  useEffect(() => {
    fetchData(`${BASE_URL}${PATH_CONTACT}`,).then((data) => {
      setContact(data);
    });
  }, []);

  useEffect(() => {
    if (cashbankType != "") {
      fetchData(`${BASE_URL}${PATH_ACCOUNT_CASH_BANK}?types=${cashbankType}`,).then((data) => {
        setCashBank(data);
      });
    }
  }, [cashbankType])

  useEffect(() => {
    setTaxes(groupByTax(accounts));
  }, [accounts]);

  useEffect(() => {
    const totalTaxes = taxes.reduce((acc, tax) => acc + (tax.totalTax || 0), 0);
    const finalTotal = subtotal + totalTaxes;

    setTaxAmount(totalTaxes);
    setTotal(finalTotal);
  }, [taxes]);

  const handleTagsChange = (tags) => {
    setSelectedTags(tags);
  };

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        ...values,
        type,
        subtotal: subtotal,
        amount: total,
        tax_amount: taxAmount,
        selectedTags,
        accounts
      };

      const response = await axios.post(`${BASE_URL}${PATH_TRANSACTION}${ENDPOINT}`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`
        }
      });

      const confirmed = confirmModal(response.data);
      if (confirmed) {
        window.location.reload();
      }
    } catch (error) {
      alert(error.response.data);

    } finally {
      setSubmitting(false);
    }
  };

  const handleAccountUpdate = (data) => {
    setAccounts(data);
  };

  const groupByTax = (items) => {
    const grouped = items.reduce((acc, item) => {
      const tax_name = item.tax_name;
      if (!acc[tax_name]) {
        acc[tax_name] = {
          tax_id: item.tax_id,
          taxRate: item.tax,
          tax_name: item.tax_name,
          items: [],
          totalTaxableAmount: 0,
          totalTax: 0,
        };
      }

      // Calculate taxable amount and tax
      const taxableAmount = item.amount;
      const tax = (taxableAmount * item.tax) / 100;

      // Update the group
      acc[tax_name].items.push(item);
      acc[tax_name].totalTaxableAmount += taxableAmount;
      acc[tax_name].totalTax += tax;

      return acc;
    }, {});

    // Convert object to array
    return Object.values(grouped);
  };

  return (
    <div className="mx-auto p-4">
      <div className='flex items-center justify-between p-5'>
        <h2 className="text-2xl font-bold">
          {titleTransaction}
        </h2>

        <div className='flex items-center'>

        </div>
      </div>

      {/* Formik Form */}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, handleChange, setFieldValue, isSubmitting }) => (
          <Form>
            <div className="container m-auto p-4">
              <div className="container m-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">

                <div className="p-3">
                  <label htmlFor="target_cashbank" className="mb-1 text-sm font-semibold">{cashbankLabel}</label>
                  <InputOption
                    label="Pilih Data"
                    data={cashbank}
                    placeholder="Ketik disini"
                    onChange={(value) => {
                      setFieldValue(`target_cashbank`, value);
                    }}
                    returnKey="code"/>      
                </div>

                <div></div>
                <div></div>
                <div></div>

                <div className="p-3">
                  <label htmlFor="contact" className="mb-1 text-sm font-semibold">{contactLabel}</label>
                  <InputOption
                    label="Pilih Akun"
                    data={contact}
                    placeholder="Ketik disini"
                    onChange={(value) => {
                      setFieldValue(`contact`, value);
                    }} />
                </div>

                <div className="p-3">
                  <label htmlFor="date" className="mb-1 text-sm font-semibold">Tgl. Transaksi</label>
                  <Field
                    type='date'
                    name="date"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                  />
                  <ErrorMessage name="date" component="p" className="text-red-500 text-xs mt-1" />
                </div>

                <div className="p-3">
                  <FormatTransaction
                    show={isFormatTransactionOpen}
                    onClose={() => setFormatTransactionOpen(false)}
                    apply={(value) => {
                      setFieldValue('no_transaction', value);
                    }} />
                  <label htmlFor="no_transaction" className="mb-1 text-sm font-semibold">
                    No. Transaksi &nbsp;
                    <button type="button" onClick={() => setFormatTransactionOpen(true)}>
                      <FontAwesomeIcon icon={faGears} />
                    </button>
                  </label>
                  <Field
                    name="no_transaction"
                    className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                  />
                  <ErrorMessage name="no_transaction" component="p" className="text-red-500 text-xs mt-1" />
                </div>

                <div className="p-3">
                  <MultiTagInput name="tags" options={['Sales', 'PPSU', 'PRSU', 'KMPSUMUT', 'TIKET']} onTagsChange={handleTagsChange} />
                </div>
              </div>

              <AccountComponent
                typesAccount={accountType}
                label={accountRelationLabel}
                onAccountUpdated={handleAccountUpdate}
                onAmountUpdated={(value) => {
                  setSubtotal(value)
                }}
              />

              <div className="container m-auto grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
                <div className="">
                  <div className="p-3">
                    <label htmlFor="notes" className="mb-1 text-sm font-semibold">Pesan</label>
                    <Field
                      as="textarea"
                      name="notes"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                  </div>
                  <div className="p-3">
                    <label htmlFor="memo" className="mb-1 text-sm font-semibold">Memo</label>
                    <Field
                      as="textarea"
                      name="memo"
                      className="my-2 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                    />
                  </div>
                </div>
                <div></div>

                <div className='col-span-2'>
                  <div className="max-w-xl mx-auto mt-8 rounded-lg px-5">
                    <div className="flex items-center justify-between mb-6">
                      <h1 className="text-lg font-semibold">Subtotal</h1>
                      <h1 className="text-lg font-semibold">Rp{subtotal.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                    </div>

                    <div className="border-t-2 border-dashed border-gray-300 my-6"></div>

                    {taxes?.map((data) => (
                      <div className="flex items-center justify-between">
                        <p>{data.tax_name}</p>
                        <p>Rp{data.totalTax.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</p>
                      </div>
                    ))}

                    <div className="border-t-2 border-dashed border-gray-300 my-6"></div>
                    <div className="flex items-center justify-between">
                      <h1 className="text-lg font-semibold">Total</h1>
                      <h1 className="text-lg font-semibold">Rp{total.toLocaleString("id-ID", { minimumFractionDigits: 2 })}</h1>
                    </div>
                  </div>
                  <div className="max-w-xl mx-auto mt-8 rounded-lg px-5">
                    <div className="flex items-center justify-end mt-5">
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                          }`}
                      >
                        {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div >
  )
}

export default TransactionCashBank;